__turbopack_context__.v({
  "customThumb": "X2xPja_customThumb",
});
